import React, { useRef } from "react"; // Added useRef
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Analytics } from "@vercel/analytics/react";
import "./index.css";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import SyntheraLaunchBar from "./components/SyntheraLaunchBar";
import VisionSection from "./components/VisionSection";
//NEW Secure Page
import DataSecuritySection from "./components/DataSecuritySection";
import AIPenetrationTesting from "./components/AIPenetrationTesting"; // Your new page
import AIReadinessAssessment from "./components/AIReadinessAssessment"; // Your new page
import SecureAIEcosystem from "./components/SecureAIEcosystem"; // Your new page
import DataSecurity from "./components/DataSecurity";
import SaseTrasformation from "./components/SaseTransformation";
import IdentitySecurity from "./components/IdentitySecurity";
import BrowserSecurity from "./components/BrowserSecurity";

// company pages
import ServiceSection from "./components/ServiceSection";
import About from "./pages/company/About";
import WhySynthera from "./pages/company/WhySynthera";
import IndustriesPage from "./pages/company/industries/industries";
import Healthcare from "./pages/company/industries/healthcare";
import MiningManufacturing from "./pages/company/industries/MiningManufacturing";
import Logistics from "./pages/company/industries/Logistics";
import Technology from "./pages/company/industries/Technology";
import RetailHospitality from "./pages/company/industries/RetailHospitality";
import FinanceInsurance from "./pages/company/industries/FinanceInsurance";
import Careers from "./pages/company/Careers";
import Contact from "./components/Contact";
import UnderAttack from "./components/UnderAttack";
import EnterpriseCyberSecurity from "./pages/Solutions/EnterpriseCyberSecurity";
import EnterpriseFeatureDetail from "./pages/Solutions/EnterpriseFeatureDetail";
import AISecurityandGovernance from "./pages/Solutions/AISecurityandGovernance";
import FeatureDetailPage from "./pages/Solutions/FeatureDetailPage";
import DataAnalytics from "./pages/Solutions/Data-Analytics";
import DataAnalyticsFeatureDetail from "./pages/Solutions/DataAnalyticsFeatureDetail";
import ManagedSecurityServices from "./pages/services/ManagedSecurityServices";
import ManagedSASEDetail from "./pages/services/ManagedSASE";
import ManagedDataSecurity from "./pages/services/ManagedDataSecurity";
import ManagedIdentitySecurity from "./pages/services/ManagedIdentitySecurity";
import ManagedEmailSecurity from "./pages/services/ManagedEmailSecurity";
import ManagedDetectionAndResponse from "./pages/services/ManagedDetectionAndResponse";
// SecurityConsultingAdvisory
import SecurityConsultingAdvisory from "./pages/services/security-consulting-advisory/SecurityConsultingAdvisory";
import GRC from "./pages/services/security-consulting-advisory/GRC";
import SecurityAwarenessEducation from "./pages/services/security-consulting-advisory/SecurityAwarenessEducation";
import PenetrationTesting from "./pages/services/security-consulting-advisory/PenetrationTesting";
import StrategyManagement from "./pages/services/security-consulting-advisory/StrategyManagement";
import SecurityArchitecture from "./pages/services/security-consulting-advisory/SecurityArchitecture";
import IncidentResponsePlan from "./pages/services/security-consulting-advisory/IncidentResponsePlan";

import GovernanceRiskCompliance from "./pages/services/governance-risk-compliance/GovernanceRiskCompliance";
import DeployAndDesign from "./pages/services/deploy-and-design/DeployAndDesign";
import IncidentResponse from "./pages/services/incident-response/incident-response";

import SolutionsSection from "./components/SolutionsSection";
//resources
import Resources from "./pages/Resources";
import ResourceLanding from "./pages/ResourceLanding"; //  new
import { resourceData } from "./data";

import BlogDetail from "./pages/BlogDetail"; // Import the new file
import VercelBlog from "./pages/VercelBlog";
import PerfectHack from "./pages/Perfecthack"; // CORRECT (Default import)
import PAMBlog from "./pages/PAMBlog";
import AgenticAIGovernanceBlog from "./pages/AgenticAIGovernanceBlog";
import ZTNABlog from "./pages/ZTNABlog"; // Adjust the path to wherever your file is saved
import BrowserSecurityBlog from "./pages/BrowserSecurityBlog"; // Adjust the path to wherever your file is saved
import Partner from "./components/Partner";
import PartnersPage from "./components/PartnersPage";
import StayUpdated from "./components/StayUpdated";
import Footer from "./components/Footer";
//cookies
import TermsOfService from "./pages/TermsOfService";
// import CookieSettings from "./pages/CookieSettings";
import CookieBanner from "./components/CookieBanner";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import BackToTopButton from "./components/BackToTopButton";

function App() {
  // 1. Create a reference for the Service Section
  const serviceSectionRef = useRef(null);

  // 2. Create the scroll function to pass to the Hero component
  const handleScrollToServices = () => {
    if (serviceSectionRef.current) {
      serviceSectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <Router>
      <ScrollToTop />

      <div className="App relative overflow-hidden">
        <header>
          <Navbar />
        </header>
        <main>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  {/* 3. Pass the scroll function to HeroSection as a prop */}
                  <HeroSection onBrowseClick={handleScrollToServices} />

                  <SyntheraLaunchBar />
                  <VisionSection />
                  <DataSecuritySection />

                  {/* 4. Wrap ServiceSection with the ref */}
                  <div ref={serviceSectionRef}>
                    <ServiceSection />
                  </div>

                  <SolutionsSection />
                  <Partner />
                  <StayUpdated />
                  <Footer />
                </>
              }
            />
            {/* New routes for the AI-focused pages */}
            <Route
              path="/AiPenetrationTesting"
              element={<AIPenetrationTesting />}
            />
            <Route
              path="/AiReadinessAssessment"
              element={<AIReadinessAssessment />}
            />
            <Route path="/SecureAIEcosystem" element={<SecureAIEcosystem />} />
            <Route path="/DataSecurity" element={<DataSecurity />} />
            <Route path="/SaseTransformation" element={<SaseTrasformation />} />
            <Route path="/IdentitySecurity" element={<IdentitySecurity />} />
            <Route path="/BrowserSecurity" element={<BrowserSecurity />} />
            {/* Company pages */}
            <Route path="/company/about" element={<About />} />
            <Route path="/company/careers" element={<Careers />} />
            <Route path="/company/why-synthera" element={<WhySynthera />} />
            {/* industries */}
            <Route path="/company/industries" element={<IndustriesPage />} />
            <Route path="/industries/healthcare" element={<Healthcare />} />
            <Route
              path="/industries/mining-manufacturing"
              element={<MiningManufacturing />}
            />
            <Route path="/industries/logistics" element={<Logistics />} />
            <Route path="/industries/technology" element={<Technology />} />
            <Route
              path="/industries/retail-hospitality"
              element={<RetailHospitality />}
            />
            <Route
              path="/industries/finance-insurance"
              element={<FinanceInsurance />}
            />
            {/* Solutions pages */}
            <Route
              path="/solutions/enterprise-cyber-security"
              element={<EnterpriseCyberSecurity />}
            />
            <Route
              path="/enterprise-security/:featureId"
              element={<EnterpriseFeatureDetail />}
            />
            <Route
              path="/solutions/ai-security-and-governance"
              element={<AISecurityandGovernance />}
            />
            <Route
              path="/solutions/ai-security-governance/:featureId"
              element={<FeatureDetailPage />}
            />
            <Route
              path="/solutions/data-analytics"
              element={<DataAnalytics />}
            />
            <Route
              path="/data-analytics/:featureId"
              element={<DataAnalyticsFeatureDetail />}
            />
            <Route path="/solutions" element={<SolutionsSection />} />
            {/* Resources page */}
            <Route path="/resources" element={<Resources />} />
            <Route
              path="/resources/:slug"
              element={<ResourceLanding resources={resourceData} />}
            />
            <Route
              path="/blog/:slug"
              element={<BlogDetail resources={resourceData} />}
            />
            <Route path="/blog/vercel-breach-ai" element={<VercelBlog />} />
            <Route
              path="/blog/perfect-hack-boardroom-strategy"
              element={<PerfectHack />}
            />
            <Route
              path="/blog/ztna-vs-vpn-future-of-secure-access"
              element={<ZTNABlog />}
            />
            <Route
              path="/blog/what-is-privileged-access-management-pam"
              element={<PAMBlog />}
            />
            <Route
              path="/blog/browser-security-blind-spot"
              element={<BrowserSecurityBlog />}
            />
            <Route
              path="/blog/agentic-ai-governance"
              element={<AgenticAIGovernanceBlog />}
            />

            {/* <Route
              path="/blog/:slug"
              element={<BlogDetail resources={resourceData} />}
            /> */}

            {/* Main Services Page */}
            <Route path="/services" element={<ServiceSection />} />
            <Route
              path="/services/managed-security-services"
              element={<ManagedSecurityServices />}
            />
            {/* Individual Detail Pages */}
            <Route
              path="/services/managed-services/sase"
              element={<ManagedSASEDetail />}
            />
            <Route
              path="/services/managed-services/data-security"
              element={<ManagedDataSecurity />}
            />
            <Route
              path="/services/managed-services/identity-security"
              element={<ManagedIdentitySecurity />}
            />
            <Route
              path="/services/managed-services/email-security"
              element={<ManagedEmailSecurity />}
            />
            <Route
              path="/services/detection-and-response"
              element={<ManagedDetectionAndResponse />}
            />
            <Route
              path="/services/security-consulting-advisory"
              element={<SecurityConsultingAdvisory />}
            />
            {/* more consulting page */}
            <Route path="/grc" element={<GRC />} />
            <Route
              path="/security-awareness"
              element={<SecurityAwarenessEducation />}
            />
            <Route path="/strategy" element={<StrategyManagement />} />
            <Route path="/pentesting" element={<PenetrationTesting />} />
            <Route path="/architecture" element={<SecurityArchitecture />} />
            <Route
              path="/incident-response-plan"
              element={<IncidentResponsePlan />}
            />
            <Route
              path="/services/governance-risk-compliance"
              element={<GovernanceRiskCompliance />}
            />
            <Route
              path="/services/design-and-deploy"
              element={<DeployAndDesign />}
            />
            <Route
              path="/services/incident-response"
              element={<IncidentResponse />}
            />
            {/* Partner page */}
            <Route path="/partnersPage" element={<PartnersPage />} />
            {/* UNDERATTACK */}
            <Route path="/under-attack" element={<UnderAttack />} />
            {/* Contact page */}
            <Route path="/contact" element={<Contact />} />
            {/* cookies  */}
            <Route path="/terms-of-service" element={<TermsOfService />} />
            {/* <Route path="/cookie-settings" element={<CookieSettings />} /> */}
          </Routes>
        </main>

        <BackToTopButton />
        <CookieBanner />
        <Analytics />

        <SpeedInsights />
      </div>
    </Router>
  );
}

export default App;
